// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-container {
  background-color: #eee;
  width: 90%;
}

.progress-bar {
  height: 24px;
  width: 0;
  text-align: center;
  color: black;
  font-size: smaller;
  font-family: "Nunito", sans-serif !important;
  font-weight: bold;
  padding-top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/progress-bar/progress-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,4CAAA;EACA,iBAAA;EACA,gBAAA;AACF","sourcesContent":[".progress-bar-container {\r\n  background-color: #eee;\r\n  width: 90%;\r\n}\r\n\r\n.progress-bar {\r\n  height: 24px;\r\n  width: 0;\r\n  text-align: center;\r\n  color: black;\r\n  font-size: smaller;\r\n  font-family: \"Nunito\", sans-serif !important;\r\n  font-weight: bold;\r\n  padding-top: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
